import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from 'split-type';

gsap.registerPlugin(ScrollTrigger);

// export function removeOnce( container ) {
//   setTimeout(() => { // Removemos la clase "once" para que saber que ya se ha cargado el ONCE
//     document.querySelector('body').classList.remove('once');
//   },3000)
// }

export function initTextClipAnimations() {
  const textClipElements = document.querySelectorAll('.txt-clip-anim');
  // console.log('Text clip elements found:', textClipElements.length);

  textClipElements.forEach((element) => {
    // Debug del atributo data-type
    const dataTypeValue = element.getAttribute('data-type');
    // console.log('Raw data-type attribute:', dataTypeValue);

    // Obtener el tipo de split del data-attribute (default: 'chars')
    const splitType = dataTypeValue === 'words' ? 'words' : 'chars';
    // Obtener el modo de animación del data-attribute (default: 'scroll')
    const animMode = element.getAttribute('data-mode') || 'scroll';
    // Obtener el valor del scroll end del data-attribute (default: '33%')
    const scrollEnd = element.getAttribute('data-scroll-end') || '40%';
    // Obtener el delay del data-attribute (default: 0.75 para mode force, 0 para mode scroll)
    const customDelay = element.getAttribute('data-delay');
    const delay = customDelay ? parseFloat(customDelay) / 1000 : (animMode === 'force' ? 0.75 : 0);
    // console.log('Split type resolved to:', splitType, 'Animation mode:', animMode, 'for element:', element);

    // Aplicar SplitType - siempre incluir words y chars para flexibilidad
    const split = new SplitType(element, {
      types: 'words, chars'
    });

    // console.log('Split result:', split);
    // console.log('Available words:', split.words);
    // console.log('Available chars:', split.chars);

    // Seleccionar elementos a animar según splitType
    const elementsToAnimate = splitType === 'words' ? split.words : split.chars;
    // console.log('Elements to animate:', elementsToAnimate);

    // Establecer estados iniciales - VERSIÓN SIMPLIFICADA SIN CLIP-PATH
    gsap.set(element, {
      overflow: 'hidden'
    });

    // Si es modo force, hacer visible el elemento antes de animar
    if (animMode === 'force') {
      gsap.set(element, { opacity: 1 });
    }

    gsap.set(elementsToAnimate, {
      y: 100, // Valor simple en pixels
      opacity: 0 // Empezar invisible para test
    });

    // Crear timeline para la animación
    let timelineConfig = {};

    // Si es modo scroll, agregar ScrollTrigger
    if (animMode === 'scroll') {
      timelineConfig.scrollTrigger = {
        trigger: element,
        start: "top 100%",
        end: `bottom ${scrollEnd}`,
        scrub: 0.5,
        // markers: true,
      };
    }

    const tl = gsap.timeline(timelineConfig);

    // VERSIÓN SIMPLE: Solo animar Y y opacity
    tl.to(elementsToAnimate, {
      y: 0,
      opacity: 1,
      duration: 0.9,
      stagger: 0.14,
      delay: delay,
      ease: "power2.out",
      // En modo force, limpiar overflow después de la animación
      onComplete: animMode === 'force' ? () => {
        gsap.set(element, { overflow: 'visible', clearProps: 'overflow' });
        gsap.set(elementsToAnimate, { clearProps: 'transform' });
      } : undefined
    });
  });
}

export function clipBox() {
  const clipboxElements = document.querySelectorAll('.clipbox');

  clipboxElements.forEach((element) => {
    // Obtener el tipo de animación del data-attribute (default: 'top-bottom')
    const animType = element.getAttribute('data-type') || 'top-bottom';
    // Obtener el valor de scrub del data-attribute (default: 'true')
    const scrubMode = element.getAttribute('data-scrub') !== 'false';
    // Obtener el valor del scroll end del data-attribute (default: '40%')
    const scrollEnd = element.getAttribute('data-scroll-end') || '40%';

    // Definir los valores de clip-path según el tipo de animación
    let fromClip, toClip;

    switch (animType) {
      case 'top-bottom':
        fromClip = "polygon(100% 0, 0 0, 0 0, 100% 0)";
        toClip = "polygon(100% 0, 0 0, 0 100%, 100% 100%)";
        break;
      case 'left-right':
        fromClip = "polygon(0 0, 0 0, 0 100%, 0% 100%)";
        toClip = "polygon(0 0, 100% 0, 100% 100%, 0 100%)";
        break;
      case 'right-left':
        fromClip = "polygon(100% 0, 100% 0, 100% 100%, 100% 100%)";
        toClip = "polygon(100% 0, 0 0, 0 100%, 100% 100%)";
        break;
      case 'bottom-top':
        fromClip = "polygon(100% 100%, 0 100%, 0 100%, 100% 100%)";
        toClip = "polygon(100% 100%, 0 100%, 0 0, 100% 0)";
        break;
      default:
        fromClip = "polygon(100% 0, 0 0, 0 0, 100% 0)";
        toClip = "polygon(100% 0, 0 0, 0 100%, 100% 100%)";
    }

    // Configurar la animación según el modo scrub
    const animationConfig = {
      clipPath: toClip
    };

    // Si scrub está habilitado, usar ScrollTrigger con scrub
    if (scrubMode) {
      animationConfig.scrollTrigger = {
        trigger: element,
        start: "top 100%",
        end: `bottom ${scrollEnd}`,
        scrub: 1,
        // markers: true
      };
    } else {
      // Si scrub está deshabilitado, usar ScrollTrigger sin scrub (one-time trigger)
      animationConfig.duration = 0.8;
      animationConfig.ease = "power2.out";
      animationConfig.scrollTrigger = {
        trigger: element,
        start: "top 80%",
        toggleActions: "play none none none"
      };
    }

    gsap.fromTo(element,
      {
        clipPath: fromClip
      },
      animationConfig
    );
  });
}
